import { EventEmitter } from "./EventEmitter";

export const EVENTS = {
	EXPANDED_WINDOW: "EXPANDED_WINDOW",
	WIDGET_STATE: "WIDGET_STATE",
	WIDGET_PART_STATE: "WIDGET_PART_STATE",
	DOWNLOAD_CSV: "DOWNLOAD_CSV",
	ID: "ID",
	CUSTOM_SORT_ENABLED: "CUSTOM_SORT_ENABLED",
	RESIZING: "MOSAIC_RESIZE",
	SCORER: "SCORER",
	SORT: "SORT",
};

export const globalEventEmitter = new EventEmitter();
